import { ColumnConfig, PrincipalPaymentsColumnKey } from '../../model';

export const sellerPaymentActionConfig: Record<
  PrincipalPaymentsColumnKey,
  ColumnConfig
> = {
  paymentId: {
    name: 'Payment Id',
    isCheckboxField: true,
    isComponent: true,
  },
  docType: {
    name: 'Doc Type',
  },
  paymentDate: {
    name: 'Payment Date',
  },
  customerName: {
    name: 'Customer Name',

    field: 'avatarNameStatus',
  },
  // typeOfPayment: {
  //   name: 'Type Of Payment',
  // },
  modeOfPayment: {
    name: 'Payment Mode',
  },
  amount: {
    name: 'Amount',
    sortField: 'amount',
  },
  status: {
    name: 'Status',
    isComponent: true,
  },
};
